import LabeledCheckBox from "components/labeledInput/LabeledCheckBox";
import { formikConnect } from "utils/formikConnect";

export default formikConnect(LabeledCheckBox);
